<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" persistent max-width="1200px">
      <v-card class="background-voucher" style="background: rgb(221, 225, 230)">
        <v-overlay absolute :value="loading_item">
          <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        </v-overlay>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title class="mb-4">
            <span class="headline"> {{ modal_title }}</span>
          </v-card-title>
          <v-card-text>
            <div class="row">
              <div class="col-md-12">
                <!--Datos Generales-->
                <DatosGenerales
                  :item="item"
                  :isViewModal="isViewModal"
                  :open="dialog"
                  :validator="$validator"
                />

                <!--Comprobantes a Pagar-->
                <ComprobanteAPagar
                  :item="item"
                  :isViewModal="isViewModal"
                  :open="dialog"
                  :validator="$validator"
                  :receiver="item.receiver"
                />

                <!--Forma de Pago y Cuenta-->
                <FormaDePago
                  :item="item"
                  :isViewModal="isViewModal"
                  :open="dialog"
                  :validator="$validator"
                  :receiver="item.receiver"
                />

                <!--Retenciones-->
                <Retenciones
                  :item="item"
                  :isViewModal="isViewModal"
                  :open="dialog"
                  :validator="$validator"
                  :receiver="item.receiver"
                  :loading_calc_retenciones="loading_calc_retenciones"
                  @setLoadingCalcRetenciones="loading_calc_retenciones = $event"
                />

                <v-row>
                  <v-col cols="12">
                    <Observation
                      :item="item"
                      :isViewModal="isViewModal"
                      subtitle="Ingrese una observación"
                    />
                  </v-col>
                </v-row>

                <v-row class="mt-0">
                  <!--Info Extra-->
                  <InfoExtra
                    :dialog="dialog"
                    :item="item"
                    :open="dialog"
                    :isViewModal="isViewModal"
                    :validator="$validator"
                  />
                  <!--Totales-->
                  <Totales 
                    :total="totalPagar"
                    :totalImputar="totalImputar"
                    :subtotalRetenciones="subtotalRetenciones"
                  />
                </v-row>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="close()">Cerrar</v-btn>
            <v-btn 
              color="success" 
              :disabled="loading_calc_retenciones"
              v-if="!isViewModal && item.state === 0"
              text 
              type="submit" 
              :loading="loading"
            >
              {{ formBtn }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import { emitterUtils } from "@/libs/utils/emitterUtils";
import { paymentOrderService } from "@/libs/ws/paymentOrderService";

import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";

import DatosGenerales from "@/views/PaymentOrder/PaymentOrderComponent/DatosGenerales.vue";
import ComprobanteAPagar from "@/views/PaymentOrder/PaymentOrderComponent/ComprobanteAPagar.vue";
import FormaDePago from "@/views/PaymentOrder/PaymentOrderComponent/FormaDePago.vue";
import Retenciones from "@/views/PaymentOrder/PaymentOrderComponent/Retenciones.vue";
import Totales from "@/views/PaymentOrder/PaymentOrderComponent/Totales.vue";
import Observation from "@/components/Comprobantes/Observation.vue";
import InfoExtra from "@/components/Comprobantes/InfoExtra.vue";

export default {
  mixins: [ModalGenericMixin],
  components: { 
    DatosGenerales, 
    ComprobanteAPagar,
    FormaDePago,
    Retenciones, 
    Totales,
    Observation,
    InfoExtra
  },
  props: {
    paymentOrder: { type: Object, default: null },
    dialog: Boolean,
    isViewModal: { type: Boolean, default: false },
    button_name: String,
    formBtn: String,
    closeDialog: Function,
    loadList: Function,
    modal_title: String
  },
  data() {
    return {
      show: false,
      loading_item: false,
      loading_calc_retenciones: false,
      formatUtils: formatUtils,
      paymentOrderService: paymentOrderService,
      defaultItem: null,
      item: {
        id: 0,
        supplier: null,
        receiver: null,
        cbte_fch: new Date(new Date().toLocaleDateString("en-US", { timeZone: "America/Buenos_Aires" })).toISOString().slice(0, 10),
        estimated_payment_date: new Date(new Date().toLocaleDateString("en-US", { timeZone: "America/Buenos_Aires" })).toISOString().slice(0, 10),
        dolar_cotiz: null,
        amount: 0,
        imp_total: 0,
        observation: null,
        payment_method: null,
        money_account: null,
        supplier_bank: null,
        spents: [],
        tributes: [],
        state: 0
      },
    };
  },
  created: function () {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.close();
      }
    });
  },
  watch: {
    dialog(val) {
      this.$validator.reset();
      this.errors.clear();
      if (val) {
        this.init();
      }
    },
  },
  computed: {
    totalImputar() {
      let total = 0.0;
      if (this.item.spents && this.item.spents.length > 0) {
        this.item.spents.forEach(spent => {
          total += parseFloat(spent.imp_total || 0);
        });
      }
      return total;
    },
    subtotalRetenciones() {
      let total = 0.0;
      if (this.item.tributes && this.item.tributes.length > 0) {
        this.item.tributes.forEach(tribute => {
          total += parseFloat(tribute.amount || 0);
        });
      }
      return total;
    },
    totalPagar() {
      // Total = Subtotal Comprobantes - Retenciones
      return this.totalImputar - this.subtotalRetenciones;
    }
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
    this.init();
  },
  methods: {
    close() {
      this.item = JSON.parse(JSON.stringify(this.defaultItem));
      this.$emit("closeDialog");
    },
    init() {
      this.item = JSON.parse(JSON.stringify(this.defaultItem));
      if (this.paymentOrder != null) {
        this.item = JSON.parse(JSON.stringify(this.paymentOrder));
        if (!this.item.spents) this.item.spents = [];
        if (!this.item.tributes) this.item.tributes = [];
        if (this.paymentOrder.id > 0) {
          this.loading_item = true;
          paymentOrderService.get(this.paymentOrder.id)
            .then((response) => {
              if (response.status) {
                this.item = response.result;
                if (!this.item.spents) this.item.spents = [];
                if (!this.item.tributes) this.item.tributes = [];
                if (this.item.state && typeof this.item.state === 'object') {
                  this.item.state = this.item.state.id;
                }
              } else {
                this.$toast.error(response.msg, "Error");
              }
            })
            .catch(() => {
              this.$toast.error("Error al cargar la solicitud de pago", "Error");
            })
            .finally(() => { this.loading_item = false; });
        }
      }
    },
    customValidations() {
      // Validar que haya al menos un comprobante
      if (this.item.spents.length === 0) {
        this.$toast.error("Debe seleccionar al menos un comprobante", "Error");
        return false;
      }

      const anchorReceiverId =
        (this.item.receiver != null ? this.item.receiver.id : null) ||
        emitterUtils.firstEmitterIdIn(this.item.spents, "spent") ||
        emitterUtils.emitterIdOf(this.item.money_account);
      if (anchorReceiverId != null) {
        const hasDifferentReceiver = this.item.spents.some((s) => emitterUtils.emitterIdOf(s.spent) != null && emitterUtils.emitterIdOf(s.spent) != anchorReceiverId);
        const hasDifferentAccount = emitterUtils.emitterIdOf(this.item.money_account) != null && emitterUtils.emitterIdOf(this.item.money_account) != anchorReceiverId;
        if (hasDifferentReceiver || hasDifferentAccount) {
          this.$toast.error("No se puede mezclar comprobantes o cuentas de diferentes receptores", "Error");
          return false;
        }
      }

      return true;
    },
    provide() {
      return {
        $validator: this.$validator,
      };
    },
    createItem(e) {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          e.preventDefault();

          if (!this.customValidations()) {
            return;
          }

          this.loading = true;

          const data = {
            id: this.item.id > 0 ? this.item.id : undefined,
            spents_arr: this.item.spents,
            supplier: this.item.supplier.id,
            receiver_id: this.item.receiver != null ? this.item.receiver.id : null,
            cbte_fch: this.item.cbte_fch,
            estimated_payment_date: this.item.estimated_payment_date,
            dolar_cotiz: this.item.dolar_cotiz,
            amount: this.totalPagar, // Total a pagar (importe sin retenciones)
            imp_total: this.totalImputar, // Total a imputar
            tributes_arr: this.item.tributes,
            observation: this.item.observation,
            payment_method_id: this.item.payment_method ? this.item.payment_method.id : null,
            money_account_id: this.item.money_account ? this.item.money_account.id : null,
            supplier_bank_id: this.item.supplier_bank ? this.item.supplier_bank.id : null
          };

          const serviceMethod = this.item.id > 0 ? paymentOrderService.update : paymentOrderService.create;

          serviceMethod(data)
            .then((response) => {
              if (response.status && response.result.id > 0) {
                this.$toast.success(
                  this.item.id > 0 ? "La orden de pago se actualizó correctamente" : "La orden de pago se creó correctamente", 
                  "OK"
                );
                this.close();
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.$toast.error(response.message, "Error");
                } else {
                  this.$toast.error(response.msg, "Error");
                }
              }
            })
            .catch((response) => {
              this.$toast.error(response.msg, "Error");
            })
            .finally(() => (this.loading = false));
        }
      });
    },
  },
};
</script>